import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get, isEqual } from 'lodash';
import { CSSTransitionGroup } from 'react-transition-group';
import TrackPlayerSlideComponent from '../../hocs/TrackPlayerSlideComponent';
import EndSessionLikertSubSlide from './EndSessionLikertSubSlide';
import EndSessionResponseSubSlide from './EndSessionResponseSubSlide';

class EndSessionSlide extends Component {
    static propTypes = {
        currentSubSlide: PropTypes.number,
        canMoveToNext: PropTypes.func,
        onChange: PropTypes.func,
        setTotalSubSlides: PropTypes.func,
        completedData: PropTypes.object
    };

    componentDidMount() {
        const { completedData: { data } = {}, canMoveToNext, setTotalSubSlides } = this.props;

        if (setTotalSubSlides) {
            setTotalSubSlides(2);
        }

        // Checks if user prev completed this section
        canMoveToNext(!!get(data, 'endSession.meetingLength', {}));
    }

    componentDidUpdate(prevProps) {
        const { completedData: { data = {} } = {}, canMoveToNext } = this.props;
        const currentEndSessionResponses = get(data, 'endSession', {});
        const prevEndSessionResponses = get(prevProps.completedData, 'data.endSession', {});

        let endSessionsSlideOneComplete = !!currentEndSessionResponses.meetingLength;
        if (!isEqual(currentEndSessionResponses, prevEndSessionResponses)) {
            if (
                currentEndSessionResponses.didMeet.value === 'Yes' &&
                currentEndSessionResponses.meetingLength &&
                currentEndSessionResponses.meetingLength.value === 'No meeting'
            ) {
                endSessionsSlideOneComplete = false;
            }
            canMoveToNext(endSessionsSlideOneComplete);
        }
    }

    handleClick = (category, value) => {
        const { completedData, onChange } = this.props;
        const existingData = get(completedData, 'data', {});
        const responseData = get(completedData, `data.endSession`);

        let answerObject;
        if (value === 'No') {
            answerObject = {
                ...existingData,
                endSession: {
                    ...responseData,
                    [category]: {
                        value
                    },
                    meetingLength: {
                        value: 'No meeting'
                    }
                }
            };
        } else {
            answerObject = {
                ...existingData,
                endSession: {
                    ...responseData,
                    [category]: {
                        value
                    }
                }
            };
        }
        onChange(answerObject, true, true);
    };

    render() {
        const { currentSubSlide, completedData } = this.props;
        let subSlide = null;
        const responseData = get(completedData, 'data.endSession', {});

        if (currentSubSlide === 1) {
            subSlide = <EndSessionResponseSubSlide handleClick={this.handleClick} responseData={responseData} />;
        } else if (currentSubSlide === 2) {
            subSlide = <EndSessionLikertSubSlide handleClick={this.handleClick} responseData={responseData} />;
        }

        return (
            <div className={'end-session-slide'}>
                <h1 className={'playerHeader verb-title-1'}>Wrap Up</h1>
                <div className={'playerContent'}>
                    <CSSTransitionGroup
                        component={'div'}
                        transitionEnter={true}
                        transitionLeave={true}
                        className={'activeSlideWrapper'}
                        transitionName={'fadeTransition'}
                        transitionEnterTimeout={460}
                        transitionLeaveTimeout={460}
                    >
                        <div key={`end-session-subslides-${currentSubSlide}`} className={'subslide-animation'}>
                            {subSlide}
                        </div>
                    </CSSTransitionGroup>
                </div>
            </div>
        );
    }
}

export const EndSessionSlideComponent = EndSessionSlide;
export default TrackPlayerSlideComponent(EndSessionSlide);
